/**
 * Aba Qualidade (plano 5.8): dado ruim aparece, não some. Cada problema com
 * a contagem e os ambientes (que abrem o painel lateral). Crítico em mais de
 * 10% da fila ou planilha sem lançamento há mais de 3 dias úteis deixam a
 * ocupação cinza — o aviso no topo diz qual dos dois.
 */
import React, { useCallback, useState } from "react";
import { FiChevronDown } from "react-icons/fi";

import { ROTULO_DO_NIVEL, TOM_DO_NIVEL } from "./apresentacao";
import ItemAmbiente from "./ItemAmbiente";
import { CabecalhoQualidade, Detalhe, ItemLista, Lista, ListaSimples, Ponto, Regua, Vazio } from "./styles";

function ItemQualidade({ item, aberto, onAlternar, podeAbrir, onAbrir }) {
  const temLista = item.itens.length > 0;
  return (
    <ItemLista>
      <CabecalhoQualidade
        type="button"
        aria-expanded={temLista ? aberto : undefined}
        disabled={!temLista}
        onClick={() => onAlternar(item.codigo)}
      >
        <span className="nivel">
          <Ponto $tom={TOM_DO_NIVEL[item.nivel]} aria-hidden="true" />
          {ROTULO_DO_NIVEL[item.nivel]}
        </span>
        <span className="rotulo" title={item.rotulo}>
          {item.rotulo}
        </span>
        <span className="qtd">{item.quantidade}</span>
        {temLista ? (
          <FiChevronDown className="seta" data-aberto={aberto ? "sim" : "nao"} size={16} aria-hidden="true" />
        ) : (
          <span />
        )}
      </CabecalhoQualidade>
      {aberto && temLista ? (
        <Detalhe>
          <ListaSimples>
            {item.itens.map((linha, i) => (
              <ItemAmbiente
                key={`${linha.identidade || linha.chave || "linha"}-${i}`}
                item={linha}
                meta={linha.linha_planilha ? `linha ${linha.linha_planilha}` : null}
                podeAbrir={podeAbrir}
                onAbrir={onAbrir}
              />
            ))}
          </ListaSimples>
        </Detalhe>
      ) : null}
    </ItemLista>
  );
}

export default function AbaQualidade({ qualidade, expandirTudo, podeAbrir, onAbrir }) {
  const [abertos, setAbertos] = useState(() => new Set());
  const alternar = useCallback((codigo) => {
    setAbertos((atual) => {
      const proximo = new Set(atual);
      if (proximo.has(codigo)) proximo.delete(codigo);
      else proximo.add(codigo);
      return proximo;
    });
  }, []);

  const itens = qualidade?.itens || [];
  if (itens.length === 0) {
    return <Vazio>Nenhum problema encontrado na planilha.</Vazio>;
  }
  return (
    <>
      <Regua>
        Crítico: muda a conta da fila. Aviso: a conta segue, mas o dado merece correção na planilha. Informação: só
        para saber.
      </Regua>
      <Lista data-pdf="capacidade-qualidade">
        {itens.map((item) => (
          <ItemQualidade
            key={item.codigo}
            item={item}
            aberto={expandirTudo || abertos.has(item.codigo)}
            onAlternar={alternar}
            podeAbrir={podeAbrir}
            onAbrir={onAbrir}
          />
        ))}
      </Lista>
    </>
  );
}
